<template>
  <TvaModal
    class="video-modal-wrapper"
    :show="show"
    dark
    @onClose="$emit('onClose')"
  >
    <div class="video-modal">
      <video-player
        class="video-modal__player"
        :src="`${$baseUrl}videos/${videoPath}.mp4`"
        controls
        disablePictureInPicture
        @mounted="autoPlayVideo"
      />
    </div>
  </TvaModal>
</template>

<script setup>
import { inject } from "vue";

import TvaModal from "./TvaModal.vue";

import "video.js/dist/video-js.css";

defineProps({
  show: Boolean,
  videoPath: String,
});

const $baseUrl = inject("$baseUrl");

function autoPlayVideo(player) {
  player.player.play();
}
</script>

<style lang="scss" scoped>
.video-modal {
  width: 100vw;
  height: calc(var(--vh) * 100);
  background-color: var(--black-100);

  &__player {
    width: 70%;
    max-height: 95%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .mobile &,
    .tablet & {
      width: 100%;
      height: 100vw;
    }

    ::v-deep(.vjs-control-bar) {
      background-color: transparent;

      .vjs-picture-in-picture-control {
        display: none;
      }

      .vjs-icon-placeholder {
        color: var(--primary-yellow);
      }

      .vjs-progress-holder,
      .vjs-volume-bar.vjs-slider-horizontal,
      .vjs-slider-bar,
      .vjs-volume-level {
        height: 2px;
      }

      .vjs-progress-holder,
      .vjs-load-progress div {
        background-color: var(--white-100);
      }

      .vjs-volume-level::before {
        content: "";
        width: 0.5rem;
        height: 0.5rem;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 50%;
        background-color: var(--white-100);
      }

      .vjs-slider-bar::before {
        display: none;
      }

      .vjs-progress-holder .vjs-slider-bar {
        background-color: var(--primary-yellow);
      }
    }
  }
}
</style>
